import { GET, PUT } from "../../utils/apicalls";
import { API } from "../../config/api";
import { Button, Card, notification } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LoadingAnimation from "../../componets/loader/loader";

function UpdateClientPage() {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();

  const fetchOneClient = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(`${API.FIND_ONE_CLIENT_DATA}${id}`, {});
      setData(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOneClient();
  }, []);

  const handleStatusToggle = async () => {
    try {
      setIsLoading(true);
      const newStatus = !data?.status;
      const updateUrl = newStatus
        ? `${API.UNBLOCK_CLIENT_DATA}${id}`
        : `${API.BLOCK_CLIENT_DATA}${id}`;
      const response: any = await PUT(updateUrl, {
        ...data,
        status: newStatus,
      });

      if (response.status) {
        notification.success({
          message: `Client status updated to "${newStatus ? "Enabled" : "Disabled"
            }" successfully!`,
        });
        setData((prev: any) => ({ ...prev, status: newStatus }));
      } else {
        notification.error({
          message: "Something went wrong. Try again later.",
        });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <h1>Client Details</h1>
      {isLoading && !data ? (
        <LoadingAnimation />
      ) : (
        data && (
          <Card title={data.clientName} bordered={false}>
            <Card>
              <p>
                <strong>Email:</strong> {data.clientEmail}
              </p>
              <p>
                <strong>Address:</strong> {data.clientAddress}
              </p>
              <p>
                <strong>Phone Number:</strong> {data.clientPhoneNumber}
              </p>
              <p>
                <strong>Alt Phone:</strong> {data.clientAltphone}
              </p>
              <p>
                <strong>Username:</strong> {data.clientUsername}
              </p>
              <p>
                <strong>Password:</strong> {data?.clientPassword}
              </p>
              <p>
                <strong>Status:</strong>
                <span style={{ color: data.status ? "green" : "red" }}>
                  {data.status ? "Enabled" : "Disabled"}
                </span>
              </p>
            </Card>
            <Button
              type={data.status ? "default" : "primary"}
              danger={data.status}
              onClick={handleStatusToggle}
              loading={isLoading}
              block
            >
              {data.status ? "Disable" : "Enable"}
            </Button>
          </Card>
        )
      )}
    </div>
  );
}

export default UpdateClientPage;
